"use client";
import "sonner/dist/styles.css";
import { Toaster as Sonner } from "sonner"

const SAFE_OFFSET = {
  top: "max(1rem, env(safe-area-inset-top))",
  right: "1rem",
  bottom: "1rem",
  left: "1rem",
};

const Toaster = ({
  ...props
}) => {
  return (
    (<Sonner
      theme="system"
      position="top-center"
      offset={SAFE_OFFSET}
      mobileOffset={SAFE_OFFSET}
      visibleToasts={4}
      closeButton
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          title: "group-[.toast]:text-foreground",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />)
  );
}

export { Toaster }
